import { FormattedMessage } from 'react-intl';
import React from 'react';
export function EmptyDiv() {
    return React.createElement("div", { className: "d-flex justify-content-center align-middle py-4 text-center text-muted w-100" },
        React.createElement(FormattedMessage, { id: "no.results" }));
}
